import {
  defaultLocale,
  localeDetection,
  localePrefix,
  localeNames,
  locales,
  pathnames,
} from './locale'

import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix,
  pathnames,
  localeDetection,
})

// 导出类型
export type Locale = (typeof locales)[number]

// 导出语言名称映射
export const languageNames: Record<Locale, string> = localeNames

// 重新导出默认值
export { defaultLocale, locales }
